import { render, staticRenderFns } from "./ResourcesWrapper.vue?vue&type=template&id=1ebcbeaa&scoped=true"
import script from "./ResourcesWrapper.vue?vue&type=script&lang=ts"
export * from "./ResourcesWrapper.vue?vue&type=script&lang=ts"
import style0 from "./ResourcesWrapper.vue?vue&type=style&index=0&id=1ebcbeaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebcbeaa",
  null
  
)

export default component.exports